<template>
  <div class="d-flex flex-row">
    <div
      class="flex-row-auto offcanvas-mobile w-300px w-xl-350px"
      id="kt_profile_aside"
    >
      <div class="card card-custom card-stretch">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-end">
            <KTDropdown2></KTDropdown2>
          </div>
          <div class="d-flex align-items-center">
            <div
              class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
            >
              <div
                class="symbol-label"
                :style="{
                  backgroundImage: `url(${currentUserPersonalInfo.photo})`
                }"
              ></div>
              <i class="symbol-badge bg-success"></i>
            </div>
            <div>
              <a
                class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                >{{ fullName }}</a
              >
            </div>
          </div>
          <!--end::User-->
          <!--begin::Contact-->
          <div class="py-9"></div>
          <!--end::Contact-->
          <!--begin::Nav-->
          <div
            class="navi navi-bold navi-hover navi-active navi-link-rounded"
            role="tablist"
          >
            <div class="navi-item mb-2">
              <a
                class="navi-link py-4 cursor-pointer active"
                @click="setActiveTab"
                data-tab="0"
                data-toggle="tab"
                role="tab"
                aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="/media/svg/icons/General/User.svg" />
                  </span>
                </span>
                <span class="navi-text font-size-lg">اطلاعات عمومی</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                class="navi-link py-4 cursor-pointer"
                @click="setActiveTab"
                data-tab="2"
                data-toggle="tab"
                role="tab"
                aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="/media/svg/icons/General/Lock.svg" />
                  </span>
                </span>
                <span class="navi-text font-size-lg">تغییر/افزودن گذرواژه</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin::Content-->
    <div class="flex-row-fluid ml-lg-8">
      <b-tabs class="hide-tabs" v-model="tabIndex">
        <b-tab active>
          <PersonalInformation></PersonalInformation>
        </b-tab>

        <b-tab>
          <ChangeCellphone></ChangeCellphone>
        </b-tab>
        <b-tab>
          <ChangePassword></ChangePassword>
        </b-tab>
      </b-tabs>
    </div>
    <!--end::Content-->
  </div>
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs > div:not(.tab-content) {
  display: none;
}
</style>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  SET_ACTIONS,
  SHOW_MOBILE_TOGGLE
} from "@/core/services/store/actions.module";
import KTDropdown2 from "@/view/content/dropdown/Dropdown2";
import PersonalInformation from "@/view/pages/profile/profile-comp/PersonalInformation";
import ChangeCellphone from "@/view/pages/profile/profile-comp/ChangeCellphone";
import ChangePassword from "@/view/pages/profile/profile-comp/ChangePassword";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";

export default {
  name: "custom-page",
  components: {
    KTDropdown2,
    PersonalInformation,
    ChangeCellphone,
    ChangePassword
  },
  data() {
    return {
      tabIndex: 0
    };
  },
  beforeMount() {
    this.$store.commit(SHOW_MOBILE_TOGGLE, true);
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "پروفایل" }]);
    this.$store.dispatch(SET_ACTIONS, {});

    new KTOffcanvas("kt_profile_aside", {
      overlay: true,
      baseClass: "offcanvas-mobile",
      //closeBy: 'kt_user_profile_aside_close',
      toggleBy: "kt_subheader_mobile_toggle"
    });
  },
  beforeDestroy() {
    this.$store.commit(SHOW_MOBILE_TOGGLE, false);
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("navi-link")) {
        target = event.target.closest(".navi-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".navi-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute("data-tab"));

      // set current active tab
      target.classList.add("active");
    }
  },
  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),

    fullName() {
      return this.gFullName(this.currentUserPersonalInfo);
    }
  }
};
</script>
